import { number } from '@lingui/core/cjs/formats';
import { MessageAction, MessageDTO } from './MessageT';
import { Dispatch } from 'react';

export type MailOutBoundConfigDTO = {
  id: number;
  provider: string;
  type: MailConfigType;
  description: string;
  email: string;
  replyToEmail: string;
  imapHost?: string | null;
  smptHost: string;
  smptPort: number;
  login: string;
  password: string;
  auth: boolean;
  startTls: boolean;
  replyTo: boolean;
  bcc: string;
  defaultAccount: boolean;
  externalAccountId: string | null;
  domainName: string | null;
  verified: boolean;
  usableForIMAP: boolean;
};

export type MailConfigType = 'SMTP' | 'SMTP_RELAY' | 'AZURE' | 'GOOGLE';

export const SkeletonMailOutBoundConfig = {
  provider: '',
  description: '',
  email: '',
  bcc: '',
  smptHost: '',
  smptPort: 587,
  login: '',
  password: '',
  auth: true,
  startTls: true,
  replyTo: true,
};

export type ProviderHint = {
  provider: string;
  text?: string;
  appSpecificPasswordLink?: string;
  twoStepVerificationLink: string | null;
};

export type AzureAccountDTO = {
  id: string;
  email: string;
  scopes: string[];
};

export type DnsEntryDTO = {
  name: string;
  value: string;
  valid: boolean;
};

export type MailgunDomainDTO = {
  domainName: string;
  verified: boolean;
  dnsEntries: DnsEntryDTO[];
};

export type MailgunDeliveryFailureReportDTO = {
  description: string;
  message: string;
  expired: boolean;
  resended: boolean;
};

export type MailFolderDto = {
  name: string;
  fullName: string;
  totalMessages: number;
  unreadMessages: number;
  selectable: boolean;
  hasChildren: boolean;
  children?: MailFolderDto[];
};

export interface BookitupEmailsCountsProps {
  unreadCount?: number | null;
  unassignedCount?: number | null;
  draftsCount?: number | null;
  scheduledCount?: number | null;
  failedCount?: number | null;
  trashCount?: number | null;
  inboxCount?: number | null;
  refreshCount: (box?: string) => void;
}

export interface EmailBoxContextProps {
  messages: MessageDTO[];
  loading: boolean;
  selectedMessage: MessageDTO | undefined;
  selectMessage: (message: MessageDTO | undefined) => unknown;
  changeEmail: (message: MessageDTO) => unknown;
  setPageNumber: (page: number) => unknown;
  prepareMessage: (action: MessageAction) => unknown;
  changeSeenFlag: (read: boolean) => void;
  changingSeenFlag: boolean;
  pageNumber: number;
  pageCount: number;
  searchQuery?: string;
  updateQuery?: Dispatch<string | undefined>;
  totalCount: number;
  refresh: () => void;
  flushMessage: () => void;
  openedFolder?: EmailFolderInfo;
  openFolder: Dispatch<EmailFolderInfo>;
  isBookitupScope: boolean;
  loadingMessage?: boolean;
}

export interface MessagesFilterIMAP {
  pageNumber: number;
  configId?: number;
  query?: string | null;
  folderName?: string;
}

export type PageWrapper = {
  pages: number;
  count: number;
  messages: MessageDTO[];
};

export type EmailFolderInfo = {
  name: string;
  fullName?: string;
  totalMessages?: number | null;
  unreadMessages?: number;
  configId?: number; // Referring to mailoutbound
  src: 'BOOKITUP' | 'IMAP';
};

export type ImapAttachmentDTO = {
  contentType: string;
  byteArray: any;
  fileName: string;
};

export interface UnreadCountProps {
  unreadCount?: number | null;
  increment: () => void;
  decrement: () => void;
  refresh: () => void;
};